// Frontend Health Check Component
import { useState, useEffect } from 'react';

const HealthCheck = ({ backendUrl }) => {
  const [healthStatus, setHealthStatus] = useState('checking');
  const [lastCheck, setLastCheck] = useState(null);

  const checkHealth = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/health`, {
        method: 'GET',
        timeout: 5000
      });
      
      if (response.ok) {
        const data = await response.json();
        setHealthStatus(data.status === 'healthy' ? 'healthy' : 'unhealthy');
      } else {
        setHealthStatus('unhealthy');
      }
      setLastCheck(new Date().toISOString());
    } catch (error) {
      console.error('Health check failed:', error);
      setHealthStatus('unhealthy');
      setLastCheck(new Date().toISOString());
    }
  };

  useEffect(() => {
    checkHealth();
    const interval = setInterval(checkHealth, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, [backendUrl]);

  // Return health status for monitoring purposes
  return {
    status: healthStatus,
    lastCheck: lastCheck,
    checkHealth: checkHealth
  };
};

export default HealthCheck;